import { render, staticRenderFns } from "./outpatientData.vue?vue&type=template&id=21329e97&scoped=true"
import script from "./outpatientData.vue?vue&type=script&lang=js"
export * from "./outpatientData.vue?vue&type=script&lang=js"
import style0 from "./outpatientData.vue?vue&type=style&index=0&id=21329e97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21329e97",
  null
  
)

export default component.exports